import { functions } from "config/firebase";
import { useComponent } from "hooks";
import { downloadUrlLink } from "consts/generales";
import useMensajeGlobal from "hooks/useMensajeGlobal";
import NeoButtonMain from "design/design_components/neo/button/NeoButtonMain.base";
import NeoTooltip from "design/design_components/neo/overlay/NeoTooltip.base";

const BotonDescargaValidaciones = (props) => {
    const componente = useComponent();
    const obtieneReporte = componente.useAsync(
        functions.httpsCallable('validacionArchivo-generaReporteResultados', { timeout: 540000 })
    );
    const { lazyParams } = props;
    const despliegaMensaje = useMensajeGlobal();

    const generaReporte = () => {
        const resolvedOptions = Intl.DateTimeFormat().resolvedOptions();
        const timeZone = resolvedOptions.timeZone;

        const parseFecha = (valor) => {
            if (!valor) return null;

            if (typeof valor === 'string') {
                const fechaSoloDia = valor.match(/^(\d{4})-(\d{2})-(\d{2})$/);
                if (fechaSoloDia) {
                    const [, anio, mes, dia] = fechaSoloDia;
                    return new Date(Number(anio), Number(mes) - 1, Number(dia));
                }
            }

            const fecha = (valor instanceof Date) ? new Date(valor.getTime()) : new Date(valor);
            if (Number.isNaN(fecha.getTime())) return null;

            return fecha;
        };

        const fechaInicioDesdeRango = lazyParams?.filters?.rangoFechas?.value?.inicio;
        const fechaFinDesdeRango = lazyParams?.filters?.rangoFechas?.value?.fin;

        const fechaInicio = parseFecha(props.fechaInicio)
            ?? parseFecha(fechaInicioDesdeRango)
            ?? (() => {
                const d = new Date();
                d.setDate(1);
                return d;
            })();
        fechaInicio.setHours(0, 0, 0, 0);

        const fechaFin = parseFecha(props.fechaFin)
            ?? parseFecha(fechaFinDesdeRango)
            ?? new Date();
        fechaFin.setHours(23, 59, 59, 999);

        const rangoFechas = {
            ...(lazyParams?.filters?.rangoFechas ?? {}),
            value: { inicio: fechaInicio, fin: fechaFin },
            matchMode: lazyParams?.filters?.rangoFechas?.matchMode ?? 'custom'
        };

        const lazyParamsConFechas = {
            ...lazyParams,
            filters: {
                ...lazyParams?.filters,
                rangoFechas
            }
        };

        obtieneReporte({
            lazyParams: JSON.stringify(lazyParamsConFechas),
            clienteId: props.clienteId,
            timeZone
        }).then((resp) => {
            if (resp?.data?.url) {
                downloadUrlLink(resp.data.url);
            }
        }).catch((error) => {
            console.log("Error: ", error);
            despliegaMensaje({
                severity: "error",
                summary: "Error:",
                detail: error.message,
            });
        })
    };

    return (<>
        <NeoTooltip target=".descarga-resultado" tooltipOptions={{ position: 'left' }} />
        <NeoButtonMain
            data-pr-position="left"
            data-pr-tooltip="Genera un archivo CSV con las validaciones realizadas."
            extra="descarga-resultado"
            loading={componente.isLoading}
            label="Descarga resultados unitarios"
            onClick={generaReporte}
        />
    </>)
}

export default BotonDescargaValidaciones;
